import { Auth0Provider } from '@auth0/auth0-react';
import FichePerso from './FichePerso';
import { useAuth0 } from "@auth0/auth0-react";
const clientId = process.env.REACT_APP_CLIENT_ID;
const domain = process.env.REACT_APP_DOMAIN;



const App = () => {

  return(
    <Auth0Provider
    domain="dev-fog2vp4ovnshvtk2.eu.auth0.com"
    clientId="WncBFYjFfEstfwUSNkHmPI2JyoUT9T6s"
    authorizationParams={{
      audience: process.env.REACT_APP_AUDIENCE,
      redirect_uri: process.env.REACT_APP_REDIRECT_URI || window.location.origin + "/"
    }}
    >
      <FichePerso></FichePerso>
    </Auth0Provider>

  );
};

export default App;
